import { useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export function useDestinationsData({
  destinations, setDestinations, setLoading,
  setPOITypeConfig,
  setMapCenter, setSearchZoom, setSelectedDestination, setSelectedAccessPoint,
  directionsDestination, setDirectionsDialogOpen, directionsOrigin, setDirectionsOrigin,
  setDirectionsDestination,
}) {
  const fetchDestinations = async (retryCount = 0) => {
    try {
      const response = await axios.get(`${API}/destinations`, { timeout: 15000 });
      setDestinations(response.data);
      setLoading(false);
    } catch (error) {
      if (retryCount < 2) setTimeout(() => fetchDestinations(retryCount + 1), Math.pow(2, retryCount) * 500);
      else { toast.error("Failed to load destinations. Please refresh the page."); setLoading(false); }
    }
  };

  const fetchPOITypes = async () => {
    try { const r = await axios.get(`${API}/pois/types`); setPOITypeConfig(r.data); } catch (error) {}
  };

  const openDirectionsDialog = (dest, e) => {
    if (e) e.stopPropagation();
    setDirectionsDestination(dest);
    setDirectionsDialogOpen(true);
  };

  const getDirections = () => {
    if (!directionsDestination) return;
    const destCoords = `${directionsDestination.latitude},${directionsDestination.longitude}`;
    const destName = encodeURIComponent(`${directionsDestination.name}, ${directionsDestination.state}`);
    const url = directionsOrigin.trim()
      ? `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(directionsOrigin.trim())}&destination=${destCoords}&destination_place_id=${destName}&travelmode=driving`
      : `https://www.google.com/maps/dir/?api=1&destination=${destCoords}&destination_place_id=${destName}&travelmode=driving`;
    window.open(url, '_blank');
    setDirectionsDialogOpen(false);
    setDirectionsOrigin("");
  };

  const handleSearchDestination = useCallback((dest) => {
    setMapCenter([dest.latitude, dest.longitude]);
    setSearchZoom(12);
    const fullDest = destinations.find(d => d.id === dest.id);
    if (fullDest) setSelectedDestination(fullDest);
    setTimeout(() => { setMapCenter(null); setSearchZoom(null); }, 2000);
  }, [destinations, setMapCenter, setSearchZoom, setSelectedDestination]);

  const handleSearchAccessPoint = useCallback((point) => {
    setMapCenter([point.latitude, point.longitude]);
    setSearchZoom(14);
    setTimeout(() => { setMapCenter(null); setSearchZoom(null); }, 2000);
  }, [setMapCenter, setSearchZoom]);

  const handleSearchLocation = useCallback((loc) => {
    setMapCenter([loc.latitude, loc.longitude]);
    setSearchZoom(10);
    setTimeout(() => { setMapCenter(null); setSearchZoom(null); }, 2000);
  }, [setMapCenter, setSearchZoom]);

  return {
    fetchDestinations, fetchPOITypes,
    openDirectionsDialog, getDirections,
    handleSearchDestination, handleSearchAccessPoint, handleSearchLocation,
  };
}
